import React from 'react';
import { motion } from 'framer-motion';
import { styles } from '../styles';
import { experiences } from '../constants';
import { SectionWrapper } from '../hoc';
import { textVariant, fadeIn } from '../utils/motion';

const ExperienceCard = ({ experience, index, isLeft }) => {
	const nodeBgClass = 'bg-white';
	const nodeBorderClass = 'border-border';

	return (
		<motion.div
			variants={fadeIn(isLeft ? 'right' : 'left', 'tween', index * 0.1, 0.5)}
			className="relative flex items-start w-full mb-12 last:mb-0">

			<div className={`w-full md:w-[calc(50%-40px)] ${isLeft ? 'md:mr-auto md:pr-10' : 'md:ml-auto md:pl-10'}`}>
				<div className="bg-warm border border-border rounded-xl p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 group">
					<div className="mb-3">
						<span className="inline-block px-3 py-1 bg-accent/5 border border-accent/15 rounded-md text-accent text-[13px] font-semibold">
							{experience.date}
						</span>
					</div>

					<h3 className="text-primary text-[18px] font-bold leading-snug">{experience.title}</h3>
					<p className="text-accent text-[14px] font-medium mt-1">{experience.company_name}</p>

					<ul className="mt-4 space-y-2">
						{experience.points.map((point, i) => (
							<li key={i} className="text-muted text-[14px] leading-relaxed flex items-start gap-2">
								<span className="text-accent mt-1.5 flex-shrink-0">
									<svg className="w-1.5 h-1.5 fill-current" viewBox="0 0 6 6"><circle cx="3" cy="3" r="3" /></svg>
								</span>
								<span className="text-left">{point}</span>
							</li>
						))}
					</ul>
				</div>
			</div>

			<div className="hidden md:flex absolute left-1/2 -translate-x-1/2 top-6 z-10">
				<motion.div
					whileHover={{ scale: 1.15 }}
					className={`w-14 h-14 rounded-full border flex items-center justify-center shadow-md shadow-accent/10 ${nodeBgClass} ${nodeBorderClass}`}>
					<img
						src={experience.icon}
						alt={`${experience.company_name} logo`}
						className="w-9 h-9 object-contain rounded-full"
					/>
				</motion.div>
			</div>
		</motion.div>
	);
};

const Experience = () => {
	return (
		<>
			<motion.div variants={textVariant(0)} className="text-center">
				<p className={styles.sectionSubText}>Career</p>
				<h2 className={styles.sectionHeadText}>Work Experience</h2>
			</motion.div>

			<motion.p
				variants={fadeIn('', '', 0.1, 0.4)}
				className="mt-4 text-muted text-[15px] text-center w-full mx-auto leading-[26px]">
				7+ years building production systems. Progressed from engineer to architect <br />through hands-on delivery, not just title changes.
			</motion.p>

			<div className="mt-14 relative">
				<div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-border -translate-x-1/2" />

				{experiences.map((experience, index) => (
					<ExperienceCard
						key={index}
						experience={experience}
						index={index}
						isLeft={index % 2 === 0}
					/>
				))}
			</div>
		</>
	);
};

export default SectionWrapper(Experience, 'work');
